const formatURL = function(urlStr, params) {
  const clean = Object.fromEntries(
    Object.entries(params || {}).filter(([, v]) => v != null)
  );
  return urlStr + '?' + new URLSearchParams(clean).toString();
}

export default formatURL
